import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { OutlineButton, PrimaryButton } from '../../../../components'
import { useHistories, useProfile, useTaskManagement } from '../../../../hooks'
import useQuery, { useGetQuery } from '../../../../hooks/useQuery'
import { ROUTES_NAME } from '../../../../constants'
import { TASK_CATEGORY_VALUE } from '../../constants'
import { Wrapper, StickyWrapper } from './styled'
import { TaskCategoryTree } from '../task-category-tree'
// import { TASK_TYPE_NAME } from '../../constants'

const getTaskCategoryList = (taskCategories) => taskCategories.map(({ id, abbr, name, taskTypeId, taskTypeName, children }) => {
  // const key = taskTypeName === TASK_TYPE_NAME.DEPARTMENT ? `department-${id}` : `attribute-${id}`
  const taskCategory = { key: id, abbr, title: name, taskTypeId, taskTypeName }
  if (children) {
    taskCategory.children = getTaskCategoryList(children)
  }
  return taskCategory
})

export const SideBar = ({ isSelectedSome, setIsModalActionVisible }) => {
  const { t } = useTranslation()
  const { profile: { userId } } = useProfile()
  const query = useQuery()
  const taskCategoryId = query.get('taskCategoryId')
  const { queryWorkspaceID } = useGetQuery()
  const history = useHistories()
  const { pathname } = history.location
  const isMyTask = pathname === ROUTES_NAME.TASK

  const { loadTaskCategoriesAction, taskCategories, isCreateTask, isEditTask } = useTaskManagement()
  const { departments, attributes } = taskCategories

  const departmentsList = getTaskCategoryList(departments)
  const attributesList = getTaskCategoryList(attributes)

  useEffect(() => {
    loadTaskCategoriesAction()
  }, [])

  const handleModalAction = () => {
    setIsModalActionVisible(true)
  }

  return (
    <Wrapper>
      <StickyWrapper>
        {/* タスク 新規作成 ボタン */}
        <PrimaryButton title={t('task.create.label')} onClick={() => history.push(`${ROUTES_NAME.CREATE_TASK}?taskCategoryId=${taskCategoryId}`)} borderRadius={6} style={{ width: '100%' }} />

        {/* アクション ボタン */}
        <OutlineButton title={t('task.action')} onClick={handleModalAction} disabled={!isMyTask || !isSelectedSome} borderRadius={6} style={{ width: '100%', marginTop: 16 }} />

        <div style={{ marginTop: 16 }}>
          <Link
            className={`my-task ${((!isCreateTask && !isEditTask && !taskCategoryId) || Number(taskCategoryId) === userId) && 'selected'}`}
            to={`${ROUTES_NAME.TASK}?taskTypeId=${TASK_CATEGORY_VALUE.MY_TASK}&taskCategoryId=${userId}${queryWorkspaceID.CONNECT}`}
            style={{ textDecoration: 'none', fontWeight: 600, paddingInline: '0.25rem' }}
          >
            {t('task.my_task')}
          </Link>
        </div>

        {departmentsList.length > 0 && (
        <>
          <div style={{ marginTop: 16, fontWeight: 600, paddingInline: '0.25rem' }}>
            {t('task.department')}
          </div>
          <TaskCategoryTree taskCategoryList={departmentsList} taskTypeId={TASK_CATEGORY_VALUE.DEPARTMENT} />
        </>
        )}

        {attributesList.length > 0 && (
          <>
            <div style={{ marginTop: 16, fontWeight: 600, paddingInline: '0.25rem' }}>
              {t('task.attribute')}
            </div>
            <TaskCategoryTree taskCategoryList={attributesList} taskTypeId={TASK_CATEGORY_VALUE.ATTRIBUTE_GROUP} />
          </>
        )}
      </StickyWrapper>
    </Wrapper>
  )
}

SideBar.propTypes = {
  isSelectedSome: PropTypes.bool,
  setIsModalActionVisible: PropTypes.func
}
